import "./Footer.scss";

function Footer() {
  return (
    <div className="footer container">
      <div className="footer-section">
        <p className="title">NKFoodHub.com</p>
        <p>
          NKFoodHub is a place where you can please your soul and tummy with
          delicious food recepies of all cuisine. And our service is absolutely
          free.
        </p>
        <p>&copy; 2023 | All Rights Reserved</p>
      </div>
      <div className="footer-section">
        <p className="title">Contact Us</p>
        <p>nkfoodhub@gmail.com</p>
        <p>+919836401740</p>
        <p>239 Street A-Nagar</p>
      </div>
      <div className="footer-section">
        <p className="title">Socials</p>
        <p>Facebook</p>
        <p>Twitter</p>
        <p>Instagram</p>
      </div>
    </div>
  );
}

export default Footer;
